var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Link as BaseRouterLink } from 'react-router-dom';
import { Link as StencilLink } from '@amzn/atoz-web/Link';
var SRouterLink = StencilLink.withComponent(BaseRouterLink);
SRouterLink.defaultProps = __assign({}, StencilLink.defaultProps);
export var RouterLink = function (_a) {
    var to = _a.to, onClick = _a.onClick, dataTestId = _a.dataTestId, children = _a.children;
    return (React.createElement(SRouterLink, { "data-testid": dataTestId, to: to, onClick: onClick }, children));
};
